import { ReactNode, useMemo, useState } from 'react';
import RegulationDataContext from '@raas/shared/src/features/regulation/contexts/RegulationDataContext';

import type { RegulationDataContextContract } from '@raas/shared/src/features/regulation/contexts/RegulationDataContext';
import type { RegulationContract } from '@raas/shared/src/features/regulation/contracts/regulation.type';
import type { IDocumentElementDetails } from '@raas/shared/src/types/document-element';

type RegulationContextProviderProps = {
  children: ReactNode;
};

export function RegulationContextProvider({ children }: RegulationContextProviderProps) {
  const [currentRegulation, setCurrentRegulation] = useState<RegulationContract | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [currentLanguage, setCurrentLanguage] = useState<string>('en');
  const [regulationContent, setRegulationContent] = useState<IDocumentElementDetails | null>(null);
  const [isLoadingContent, setIsLoadingContent] = useState<boolean>(false);

  const dataValue: RegulationDataContextContract = useMemo(
    () => ({
      currentRegulation,
      isLoading,
      setCurrentRegulation,
      setIsLoading,
      currentLanguage,
      setCurrentLanguage,
      regulationContent,
      setRegulationContent,
      isLoadingContent,
      setIsLoadingContent,
    }),
    [
      currentRegulation,
      isLoading,
      setCurrentRegulation,
      setIsLoading,
      currentLanguage,
      setCurrentLanguage,
      regulationContent,
      setRegulationContent,
      isLoadingContent,
      setIsLoadingContent,
    ]
  );
  return (
    <RegulationDataContext.Provider value={dataValue}>{children}</RegulationDataContext.Provider>
  );
}
